import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgbxxmm8ut: FaireProductEntity = {
  token: "p_sgbxxmm8ut",
  type: "product",
  name: "KAF Home Farm Stripe Flour Sack Kitchen Towel - Set of 4",
  brandName: "KAF Home",
  imageUrl:
    "https://cdn.faire.com/fastly/2322df2cfd7ff9cb51486255fc47128a08c98f23232894d458b2f0429cea67b1.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ce1f717516fae572af6a77ebde231a537ee118797e97df3cd3affda638ebf709.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
